import '../../sass/blocks/video-hero.scss';

(() => {
    const $videoHeros = document.querySelectorAll('.video-hero');

    if (!$videoHeros.length) return;

    $videoHeros.forEach($videoHero => {
        const $video = $videoHero.querySelector('.video-hero__video');

        const initVideo = () => {
            if (!$video) return;

            const player = new Vimeo.Player($video);

            player.on('timeupdate', function(data) {
                if (data.duration > 0 && data.seconds >= data.duration - 0.2) {
                    player.pause();
                }
            });
        };

        initVideo();
    });
})();
